import React from 'react';

export const RulesContentContext = React.createContext<{
  openedRules?: string[];
  openRule?: (id: string) => void;
  closeRule?: (id: string) => void;
  closeAllRules?: () => void;
  showCreationForm?: () => void;
}>({});
